import styled from 'styled-components';

import colors from '../../../../../../styles/colors';

const SharedWorkoutMessage = styled.div`
  margin: 10px 45px;
  font-size: 14px;
  color: ${colors.base.secondary2};
  line-height: 148%;
`;

const NewWorkoutNameField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 10px 45px;
`;

const NewWorkoutNameInput = styled.input`
  width: 100%;
  height: 35px;
  padding: 4px 8px;
  font-size: 14px;
  border: 1px solid ${colors.shades.secondary7};
  border-radius: 4px;
  color: ${colors.base.secondary2};
  outline: none;

  &:focus {
    border-color: ${colors.base.primary};
  }
`;

export {
  SharedWorkoutMessage,
  NewWorkoutNameField,
  NewWorkoutNameInput,
};
